import { useEffect, useState } from "react";
import { Tag } from "../DownloadForm";

export const useTagSelection = (availableTags?: Tag[]) => {
  const [selectedTags, setSelectedTags] = useState<Tag[]>([]);
  const [tagSelectionError, setTagSelectionError] = useState<string>("");

  useEffect(() => {
    if (!availableTags || selectedTags.length === 0) {
      return;
    }
    const validTags = filterInvalidTags(selectedTags, availableTags);
    const hasInvalidTags = validTags.length !== selectedTags.length;
    if (hasInvalidTags) {
      setSelectedTags(validTags);
    }
  }, [availableTags, selectedTags]);

  const filterInvalidTags = (
    selectedTags: Tag[],
    availableTags: Tag[],
  ): Tag[] => {
    return selectedTags.filter((selectedTag) =>
      availableTags.some((tag) => tag.id === selectedTag.id),
    );
  };

  const applySelectedTags = (tags: Tag[]) => {
    setSelectedTags(tags);
    setTagSelectionError("");
  };

  const removeTag = (tagId: string) =>
    setSelectedTags((prev) => prev.filter((tag) => tag.id !== tagId));

  const validateTagSelection = (): boolean => {
    const hasSelectedTags = selectedTags.length > 0;
    const errorMessage = hasSelectedTags ? "" : "タグを選択してください";
    setTagSelectionError(errorMessage);
    return hasSelectedTags;
  };

  return {
    selectedTags,
    tagSelectionError,
    applySelectedTags,
    removeTag,
    validateTagSelection,
  };
};
